import axios from "axios";
import store from "services/structure/store";

const api = axios.create({
  baseURL: process.env.REACT_APP_REST_BASE_URL,
});

api.interceptors.request.use(async (config) => {
  const token = store.getState()?.authState?.token;
  const tenant = store.getState()?.layoutState?.tenant;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.tenant = tenant;
  }
  return config;
});

export default api;
